import { createApp, App as VueApp } from 'vue';
import { FontAwesomePlugin } from '@/fontawesome';
import router from '@/router';
import VueTextareaAutosize from 'vue-textarea-autosize';
import FloatingVue from 'floating-vue';
import Toastification from 'vue-toastification';
import Vue3Sanitize from 'vue-3-sanitize';
import VueClickAway from 'vue3-click-away';
import ComponentLibrary from '@shared/designsystem';
import VCalendar from 'v-calendar';
import { store } from '@/store'; // If needed

export function createAppWithPlugins(rootComponent: any, props: Record<string, any> = {}): VueApp {
  const isInitialAppRender = Object.keys(props).length === 0;

  const app = createApp(rootComponent, props);
  app.use(FontAwesomePlugin);
  app.use(VueTextareaAutosize);
  app.use(FloatingVue);
  app.use(Vue3Sanitize);
  app.use(ComponentLibrary);
  app.use(VCalendar, { componentPrefix: 'vc' });
  app.use(store);

  if (isInitialAppRender) {
    app.use(Toastification);
    app.use(VueClickAway);
    app.use(router);
  }

  return app;
}
